module.exports = __webpack_public_path__ + "img/icon-login-logo@2x.3042e32e.png";